module.exports = __webpack_public_path__ + "static/media/03_06.39aae03e.png";